<script lang="ts">
  import { type Size, SIZE_MAP } from './icon';
  interface Props {
    size?: Size;
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    [key: string]: any;
  }
  let { size = $bindable('md'), ...rest }: Props = $props();
  let computedSize = $derived(SIZE_MAP[size] as Size);
</script>

<svg
  xmlns="http://www.w3.org/2000/svg"
  width={computedSize}
  height={computedSize}
  viewBox="0 0 24 24"
  {...rest}>
  <g>
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M12 2c5.523 0 10 4.477 10 10s-4.477 10-10 10S2 17.523 2 12 6.477 2 12 2ZM4.546 9.09a8.002 8.002 0 0 0 6.096 10.796l.248.038 1.708-2.96a5 5 0 0 1-4.86-2.35L4.546 9.09ZM19.419 9H16c.628.836 1 1.874 1 3 0 .942-.26 1.823-.713 2.575l-3.08 5.335A8 8 0 0 0 19.419 9ZM12 9a3 3 0 1 0 0 6 3 3 0 0 0 0-6Zm0-5a7.98 7.98 0 0 0-6.134 2.864l-.172.213L7.4 10.034a5 5 0 0 1 4.362-3.028L12 7h6.245A7.99 7.99 0 0 0 12 4Z"
      fill="currentColor" />
  </g>
</svg>
